import React, { useEffect } from "react";
import { Button, Container, Row, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DefaultLayout from "../../components/layout/DefaultLayout";
import { fetchResourcesAction, deleteResourceAction } from "./freeResourceAction";

const FreeResources = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { resources, isLoading } = useSelector((state) => state.freeResource);

  useEffect(() => {
    dispatch(fetchResourcesAction());
  }, [dispatch]);

  const handleOnDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this resource?")) {
      dispatch(deleteResourceAction(id));
    }
  };

  console.log("Resources in state:", resources);

  return (
    <DefaultLayout>
      <Container>
        <Row className="mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h1>Free Resources</h1>
            <Button variant="warning" onClick={() => navigate("/free-resources/create")}>
              Add New Resource
            </Button>
          </div>
        </Row>
        <hr />
        <Row className="mt-3">
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Destination URL</th>
                <th>Added By</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {resources.length > 0 ? (
                resources.map((item, i) => (
                  <tr key={item._id}>
                    <td>{i + 1}</td>
                    <td>{item.name}</td>
                    <td>
                      <a href={item.destinationUrl} target="_blank" rel="noreferrer">
                        {item.destinationUrl}
                      </a>
                    </td>
                    <td>{item.addedBy}</td>
                    <td>
                      <span
                        className={`badge bg-${
                          item.status === "active" ? "success" : "secondary"
                        }`}
                      >
                        {item.status}
                      </span>
                    </td>
                    <td className="text-center">
                      <Button
                        variant="warning"
                        className="me-2"
                        onClick={() => navigate(`/free-resources/edit/${item._id}`)}
                      >
                        <i className="fa-solid fa-pen-to-square"></i>
                      </Button>
                      <Button variant="danger" onClick={() => handleOnDelete(item._id)}>
                        <i className="fa-solid fa-trash"></i>
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No resources found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Row>
      </Container>
    </DefaultLayout>
  );
};

export default FreeResources;
